export const applicationFormStateStorageKey = 'applicationForm';

export const removeApplicationFormAnswerState = () => {
  try {
    window.localStorage.removeItem(applicationFormStateStorageKey);
  } catch (e) {
    console.error(e);
  }
};
